import {PrismicNextImage} from '@prismicio/next/pages'
import {useLinkResolver} from 'prismicio'
import type {
  PricingSectionSliceLargePrimaryCtaContentItem,
  PricingSectionSliceLargePrimaryCtaImagesItem,
} from 'prismicio-types'
import {ButtonV2} from 'src/common/ButtonV2'

export const CTASectionLarge = ({
  images,
  content,
  componentIndex,
  pageUid,
}: {
  images: PricingSectionSliceLargePrimaryCtaImagesItem[]
  content: PricingSectionSliceLargePrimaryCtaContentItem
  componentIndex: number
  pageUid: string
}) => {
  const {linkResolver} = useLinkResolver()

  return (
    <div className="flex flex-col items-center gap-4">
      <div className="isolate flex items-center">
        {images.map((image, index) => (
          <div
            key={index}
            className="ml-[-5px] flex h-[34px] w-[34px] items-center justify-center overflow-hidden rounded-full border-[2px] border-solid border-moss-grey-100 bg-moss-grey-200"
            style={{zIndex: 0 - index}}
          >
            <PrismicNextImage key={index} field={image.image} alt="" />
          </div>
        ))}
      </div>
      <div className="flex flex-col items-center gap-2">
        <h5 className="text-center text-[24px] font-medium leading-[normal] text-moss-black">{content?.title}</h5>
        <p className="text-tg-body-l text-moss-grey-550">{content?.description}</p>
      </div>
      <ButtonV2
        variant="primary"
        href={linkResolver(content?.button_link)}
        trackingData={{
          location: `component-${componentIndex}-pricing-section`,
          dataType: `primary-button`,
          pageName: pageUid,
          mktgId: `pricing-section-cta-button`,
        }}
      >
        {content?.button_link?.text}
      </ButtonV2>
    </div>
  )
}
